<form #thisForm="ngForm" (ngSubmit)="submit()">
  <app-dados-boleta
    titulo="Dados da Boleta - Renda Fixa - Título Público"
    [operationDate]="model.operationDate"
    [id]="model.id"
    [accountManagerName]="model.accountManagerName"
    [accountManagerDocument]="model.accountManagerDocument"
    [statusDescription]="model.statusDescription"
  >
  </app-dados-boleta>

  <div class="row">
    <div class="col-md-6 col-12">
      <div class="card mt-3">
        <div class="card-header text-uppercase">Tipo de Liquidação</div>
        <div class="card-body">
          <div class="col-12">
            <div [class.has-error]="hasError('settlementTypeId')">
              <div
                class="form-check form-check-inline"
                *ngFor="let item of TiposLiquidacao; index as i"
              >
                <input
                  class="form-check-input"
                  type="radio"
                  id="TipoLiquidacao-{{ i }}-id"
                  name="settlementTypeId"
                  [(ngModel)]="model.settlementTypeId"
                  [value]="item.id"
                  required
                  (change)="clearPublicSecurityFields()"
                />

                <label class="form-check-label" for="TipoLiquidacao-{{ i }}-id">
                  {{ item.name }}
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-6 col-12">
      <div class="card mt-3">
        <div class="card-header text-uppercase">Tipo de Operação</div>
        <div class="card-body">
          <div class="col-12">
            <div [class.has-error]="hasError('operationTypeId')">
              <div
                class="form-check form-check-inline"
                *ngFor="let item of TiposCompra; index as i"
              >
                <input
                  class="form-check-input"
                  type="radio"
                  id="TipoOperacao-{{ i }}-id"
                  name="operationTypeId"
                  [(ngModel)]="model.operationTypeId"
                  [value]="item.id"
                  required
                  (change)="clearPublicSecurityFields()"
                />

                <label class="form-check-label" for="TipoOperacao-{{ i }}-id">
                  {{ item.name }}
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <app-dados-fundo
    #portfolio
    [canEdit]="canEdit()"
    [canValidate]="canValidate"
    [ticketType]="TicketTypeEnum.SELIC"
    [operationType]="model.operationTypeId"
    (emitterStockSelectedItem)="getStockSelectedFixedIncome($event)"
  ></app-dados-fundo>

  <div class="card mt-3">
    <div class="card-header">Dados da Operação</div>
    <div class="card-body">
      <div class="row mb-2">
        <div
          class="col-2"
          *ngIf="isSell()"
          [class.has-error]="hasError('acquisitionDate')"
        >
          <label>Data Aquisição</label>
          <input
            placeholder="Select date"
            type="date"
            class="form-control"
            name="acquisitionDate"
            data-cy="acquisitionDate"
            [(ngModel)]="model.acquisitionDate"
            required
          />
        </div>
        <div class="col-2" [class.has-error]="hasError('amount')">
          <label>Quantidade</label>
          <input
            type="text"
            class="form-control"
            name="amount"
            data-cy="amount"
            [(ngModel)]="model.amount"
            (ngModelChange)="calculateOperationValue()"
          />
        </div>

        <div class="col-2" [class.has-error]="hasError('unitPrice')">
          <label>PU (Preço Unitário)</label>
          <input
            type="text"
            class="form-control"
            data-cy="unitPrice"
            name="unitPrice"
            [(ngModel)]="model.unitPrice"
            [textMask]="{ mask: validator.unitPriceMask }"
            maxlength="25"
            required
            (ngModelChange)="calculateOperationValue()"
          />
        </div>

        <div class="col-2" [class.has-error]="hasError('operationValue')">
          <label
            >Valor da Operação
            <fa-icon
              [icon]="faInfoCircle"
              title="Valor Alterado"
              *ngIf="isOperationValueModified()"
            ></fa-icon>
          </label>
          <input
            type="text"
            class="form-control"
            data-cy="operationValue"
            name="operationValue"
            [(ngModel)]="model.operationValue"
            [textMask]="{ mask: validator.operationValueMask }"
            required
          />
        </div>
        <div class="form-group col-md-4">
          <label>Comando</label>
          <input
            class="form-control text-box single-line"
            type="text"
            data-cy="command"
            name="command"
            [(ngModel)]="model.command"
            maxlength="8"
            value=""
          />
        </div>
        <app-out-custody></app-out-custody>
      </div>

      <div
        class="col-2"
        *ngIf="isTermo()"
        [class.has-error]="hasError('settlementDate')"
      >
        <label>Data Liquidação</label>
        <input
          placeholder="Select date"
          type="date"
          class="form-control"
          name="settlementDate"
          data-cy="settlementDate"
          [(ngModel)]="model.settlementDate"
          required
        />
      </div>
      <div class="offset-2"></div>

      <div class="row mb-2">
        <div class="col-4" [class.has-error]="hasError('security')">
          <label>Nome do Título</label>
          <ng-select
            [searchable]="false"
            [(ngModel)]="selectedPublicSecurityType"
            [ngModelOptions]="{ standalone: true }"
            (change)="publicSecurityTypeSelected()"
            [disabled]="!canEdit()"
            required
          >
            <ng-option
              *ngFor="let item of publicSecurityTypes"
              [value]="item"
              >{{ item }}</ng-option
            >
          </ng-select>
        </div>

        <div class="col-4" [class.has-error]="hasError('securityId')">
          <label>Código Título</label>
          <ng-select
            [searchable]="false"
            [(ngModel)]="model.securityId"
            [ngModelOptions]="{ standalone: true }"
            required
            (change)="publicSecurityIdSelected()"
            [disabled]="!canEdit()"
          >
            <ng-option
              *ngFor="let publicSecurity of publicSecurityIdsList"
              [value]="publicSecurity"
              >{{ publicSecurity }}</ng-option
            >
          </ng-select>
        </div>

        <div class="col-4" [class.has-error]="hasError('expirationDate')">
          <label>Data Vencimento</label>
          <ng-select
            [searchable]="false"
            [(ngModel)]="selectedPublicSecurityItem"
            [ngModelOptions]="{ standalone: true }"
            (change)="publicSecurityItemSelected()"
            [disabled]="!canEdit()"
          >
            <ng-option
              *ngFor="let publicSecurity of publicSecurityList"
              [value]="publicSecurity"
              >{{ publicSecurity.expirationDate }}</ng-option
            >
          </ng-select>
        </div>
      </div>
    </div>
  </div>

  <br />

  <app-counterpart
    #counterpart
    [ticketType]="TicketTypeEnum.SELIC"
    [canEdit]="canEdit()"
    [canValidate]="canValidate"
    [model]="this.model"
  ></app-counterpart>

  <app-annotation #annotation [annotation]="model.annotations"></app-annotation>

  <div class="actions" *ngIf="canEdit()">
    <input
      type="button"
      data-cy="submit"
      value="Salvar"
      class="btn btn-primary me-2"
      [disabled]="!canEdit()"
      appDebounceClick
      (debounceClick)="submit()"
      [debounceTime]="200"
    />
    <input
      type="button"
      data-cy="forward"
      value="Encaminhar"
      class="btn btn-primary me-2"
      [disabled]="!canEdit()"
      appDebounceClick
      (debounceClick)="forward()"
      [debounceTime]="200"
    />
    <input
      type="button"
      value="Cancelar"
      class="btn btn-danger me-2"
      [disabled]="!canCancel()"
      appDebounceClick
      (debounceClick)="cancel()"
      [debounceTime]="200"
    />
  </div>

  <div class="actions" *ngIf="canChangeStatus()">
    <input
      type="button"
      value="Aprovar"
      data-cy="approve"
      class="btn btn-success me-2"
      appDebounceClick
      (debounceClick)="approve()"
      [debounceTime]="200"
    />
    <input
      type="button"
      value="Reprovar"
      data-cy="reject"
      class="btn btn-danger me-2"
      appDebounceClick
      (debounceClick)="reject()"
      [debounceTime]="200"
    />
  </div>

  <div class="actions" *ngIf="canDuplicate()">
    <input
      type="button"
      value="Duplicar"
      data-cy="duplicate"
      class="btn btn-primary me-2"
      [disabled]="!model.id"
      appDebounceClick
      (debounceClick)="duplicate()"
      [debounceTime]="200"
    />
  </div>
</form>

<app-workflow-history
  [ticketId]="model.id"
  [refresh]="dataChanged"
></app-workflow-history>
